export const TINY_MCE_API_KEY = 'lsma73xyw3emf5gmdaqeotkqmruiprcn5jpi8nwupyyvubvp'